import { setupLinkClient } from "./components/oidc";
import { initialConfigs } from "./configs/initialConfig";
import { getIdpPathParam } from "./utils/utils";

function setupOidcClient() {
    return initialConfigs().then((config) => {
        const idpHint = getIdpPathParam();
        return setupLinkClient(config.linkIdPUri, config.linkClientId, idpHint);
    });
}

export const oidcClient = setupOidcClient();
